import { Box, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import '../../style/Login.scss'
import TextBox from '../../common/TextBox'
import MButton from '../../common/MButton'
import { useDispatch } from 'react-redux'
import { showErrorAlert, userLogin } from '../../redux/Actions'
import { focusElemnt, navigation1, navigation3 } from '../../utils/helpers'
import useChkParam from '../../hook/useChkParam'
import { useNavigate } from 'react-router-dom'
const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [filterValue, setFilterValue] = useState({
    code: '',
    loginId: '',
    password: ''
  });
  useEffect(() => {
    focusElemnt('code')
  }, [])

  const handleUserLogin = (body) => {
    dispatch(userLogin(body)).then((res) => {
      if (!res.data.status) {
        dispatch(showErrorAlert(res.data.message || 'Login failed'));
      } else if (res?.data?.status && Object.keys(res.data.Data).length === 0) {
        dispatch(showErrorAlert('Invalid login credentials'));
      }
      navigate('/')
    }).catch((err) => {
      console.error('Login failed:', err);
    });
  }
  useChkParam(handleUserLogin)


  useEffect(() => {
    const handleKeyDown = (e) => {
      if (
        e.key === "F12" ||
        (e.ctrlKey &&
          e.shiftKey &&
          ["I", "J", "C"].includes(e.key.toUpperCase())) ||
        (e.ctrlKey && e.key.toUpperCase() === "U")
      ) {
        e.preventDefault();
      }
    };

    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("contextmenu", handleContextMenu);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterValue((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle login logic here
  const handleLogin = () => {
    if (filterValue?.code?.toString()?.trim() === '') {
      dispatch(showErrorAlert('Please enter code', 'code'))
    } else if (filterValue?.loginId?.toString()?.trim() === '') {
      dispatch(showErrorAlert('Please enter login ID', 'loginId'))
    } else if (filterValue?.password?.toString()?.trim() === '') {
      dispatch(showErrorAlert('Please enter password', 'password'))
    } else {
      const body = {
        Code: filterValue?.code,
        LoginID: filterValue?.loginId,
        Password: filterValue?.password
      }
      handleUserLogin(body)

    }
  }

  return (
    <Box className='login_page container'>
      <Box className='login--wrapper'>
        <Box className='header--section'>
          <Box className='logo--section'>
            <img src="./images/maventech-logo.png" alt="BBT Logo" />
          </Box>
          <Typography>Book Bus Ticket</Typography>
        </Box>
        <Box className='form--section'>
          <Box className='smallTextBox36'>
            <TextBox label='Enter Code' type='text' onChange={handleChange} id='code' name='code'
              onKeyDown={(event) => {
                navigation1(event, 'loginId', 'Login')
              }}
            />
          </Box>
          <Box className='smallTextBox36'>
            <TextBox label='Enter Login ID' type='text' onChange={handleChange} id='loginId' name='loginId'
              onKeyDown={(event) => {
                navigation1(event, 'password', 'code')
              }}
            />
          </Box>
          <Box className='smallTextBox36'>
            <TextBox label='Enter Password' type='text' isPassWord={true} onChange={handleChange} id='password' name='password'
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  handleLogin()
                }
                navigation1(event, 'Login', 'loginId')
              }}
            />
          </Box>
          <MButton btnName='Login' className='btn-orange36' id='Login' onClick={handleLogin}
            onKeyDown={(event) => {
              navigation3(event, 'code', 'password', () => {
                handleLogin()
              })
            }}
          />
        </Box>
        <Box className="bottom-section">

          <Box className="bottom-text">
            You agree to our <a href="/terms_of_use" target="_blank" rel="noreferrer">Terms of Use</a> agreement and <a target="_blank" rel="noreferrer" href="/privacy_policy">Privacy Policy</a>
          </Box>
          <Box className="helpline--wrapper"  >
            MavenTech Labs Helpline 08065927752 (10:30 AM to 08:30 PM)
          </Box>
          <Box className="copy--right--txt"> &copy; {new Date().getFullYear()} Operated by Maventech Labs Private Limited.</Box>
        </Box>
      </Box>
      <Box className='footer-image--wrapper'>
        <img key='footer-image' src="./images/footerImage.png" alt="Maventech Labs Pvt Ltd." />
      </Box>
    </Box>
  )
}

export default Login